const option = {
  style: "percent",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

const formatter = new Intl.NumberFormat("en-US", option);

export const numberToPercent = formatter.format;
